<template>
  <div>
    <div class="operation">
     <a-button type="primary" @click="$add({ pid: $route.query.pid })"> 新增 </a-button>
      <a-input-search
        style="width: 200px"
        v-model:value="keyword"
        enter-button
        @search="$search(keyword)"
      />
    </div>
    <a-table
      borderedÎ
      :data-source="dataSource"
      :columns="columns"
      :pagination="false"
    >
      <template> </template>
      <template #operation="{ record }">
        <a @click="$detail(record.id)">详情</a>
        <a-divider type="vertical" />
        <a-popconfirm
          v-if="dataSource.length"
          title="确认删除？"
          @confirm="$del(record.id)"
        >
          <a>删除</a>
        </a-popconfirm>
      </template>
    </a-table>
  </div>
</template>
<script>
// 新的数据在上面 老的下面
export default {
  data() {
    return {
      targetName:"demand",
      keyword: "",
      searchFile: 'num',
      dataSource: [],
      columns: [
        {
          title: "编号",
          dataIndex: "num",
          width: "80%",
        },
        {
          title: "操作",
          width: "20%",
          dataIndex: "operation",
          slots: { customRender: "operation" },
        },
      ],
    };
  },
  // 初始化数据
  async mounted() {
    await this.init();
  },
  methods: {
    // 初始化函数
    async init() {
      this.keyword = this.$route.query.keyword;
      let query = new this.$lc.Query(this.targetName)
      query.equalTo("pid", this.$route.query.pid);
      await this.$loadList('createdAt', query)
    },
  },
};
</script>
<style lang="scss">
.operation {
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  align-content: center;
}
.editable-cell {
  position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
  padding-right: 24px;
}

.editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
  position: absolute;
  right: 0;
  width: 20px;
  cursor: pointer;
}

.editable-cell-icon {
  line-height: 18px;
  display: none;
}

.editable-cell-icon-check {
  line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: #108ee9;
}

.editable-add-btn {
  margin-bottom: 8px;
}
</style>
